/** Stable cell identifier for URLs and screenshot baselines. */
export function buildMatrixCellId(parts: {
  componentType: string;
  themeId: string;
  colorsetId: string;
  spacingEnum: string;
  locale: string;
  fixtureId: string;
}): string {
  return [
    parts.componentType,
    parts.themeId,
    parts.colorsetId,
    parts.spacingEnum,
    parts.locale,
    parts.fixtureId,
  ].join('::');
}

export function buildPageCellId(parts: {
  pageFixtureId: string;
  themeId: string;
  colorsetId: string;
  spacingEnum: string;
  locale: string;
}): string {
  return [
    parts.pageFixtureId,
    parts.themeId,
    parts.colorsetId,
    parts.spacingEnum,
    parts.locale,
  ].join('::');
}
